export default __webpack_public_path__ + "static/media/member4.39dc3eaa.jpg";